<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Swal from "sweetalert2";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'
// register the plugin on vue
import Toasted from 'vue-toasted';

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
/**
 * Marcas component
 */
export default {
  page: {
    title: "Marcas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout, PageHeader,Loader,Vuetable,VuetablePagination, "fulfilling-bouncing-circle-spinner":FulfillingBouncingCircleSpinner},
  data() {
    return {
      userT : this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token}
      },
       repit : true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL +"marcas/get",
       css: {
      table: {
        tableClass: 'table table-striped table-bordered table-hovered',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      pagination: {
        infoClass: 'pull-left',
        wrapperClass: 'vuetable-pagination pull-right',
        activeClass: 'btn-primary',
        disabledClass: 'disabled',
        pageClass: 'btn btn-border',
        linkClass: 'btn btn-border',
        icons: {
          first: '',
          prev: '',
          next: '',
          last: '',
        },
      }
    },
      formMarca: {
        nombre: "",
        descripcion: "",
        state: true,
        id: 0,
      },
      updating: false,
      estadotabla:true,
      title: "Marcas",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Marcas",
          active: true,
        },
      ],
      fields: [
        {
          name: 'nombre_marca',
          title: 'Nombre',
          sortField: 'nombre_marca',
          width: "30%",
        },
        {
          name: 'descripcion_marca',
          title: 'Descripción',
          sortField: 'descripcion_marca',
          width: "40%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "20%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        }
      ],
       searchType: [
        { nombre: "Nombre", value: "nombre" },
      ],
      options : {
          theme: "outline",  
          position: "top-right", 
          duration : 5000,
          keepOnHover:true,
          action : {
            text : 'X',
            onClick : (e, toastObject) => {
                toastObject.goAway(0);
          },
         
    },
      },
       loadingtable:false,
       sortBy: "nombre_marca",
       sortDesc: false,
       searchLabel: { nombre: "Nombre", value: "nombre" },
       filterLabel: { nombre: "Nombre", value: "nombre" },
       showModalL: false,
       showModalN: false,
       showModalD: false,
       showModalA: false,
       showModalE: false,
       submitted : false,
       data:[],
       items: [],
       pageOptions: [4, 10, 15, 20],
       search: "",
        page: 1,
        perPage: 4,
        from: 0,
        to: 0,
        total: 0,
        lastPage: 0,
    };
  },
  validations: {
    formMarca: {
      nombre: {
        required,
        async isUnique (value) {
            if (value === '') return true
            // simulate async call, fail for all logins with even length
            let response = await axios.get( this.apiUrl +'marcas/nombre_repetido?nombre='+ value  + '&id='+this.formMarca.id,{
            headers: { "x-token": this.userT.token}
          }).catch(console.log);
            this.repit = response.data.msg;
            return response.data.msg
        } 
      },
      descripcion: { required },
    },
  },
  mounted() {
   
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
   watch: {
  
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    limpiarModal(){
      this.formMarca.nombre = '';
      this.formMarca.id = 0;
      this.formMarca.descripcion = '';
    },
  //modal y validaciones

     validaciones(opc) {
      this.submitted = true;
      // console.log(this.repit)
      // stop here if form is invalid

      this.$v.$touch();
      // console.log(this.$v.$invalid, this.repit);
      if (this.$v.$invalid || this.repit == false) {
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
        if (opc == "update") {
          this.update();
        }
      }
      
      
    },
    //Desactivar registro
    desactivate(){
      const {id,nombre } =this.formMarca;
      axios
          .put(process.env.VUE_APP_URL + "marcas/desactivate", {
            id: id,
          },{
            headers: { "x-token": this.userT.token}
          })
          .then(() => {
             this.showModalD = false;
              Vue.toasted.error((nombre+" Desactivado"),this.options);
          

            this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
             Vue.toasted.error("Error para desactivar",this.options);
          
          });
      
   
    },

    //ACtivar registro
    activate(){
     const {id,nombre  } =this.formMarca;
     axios
          .put(process.env.VUE_APP_URL + "marcas/activate", {
            id: id,
          },{
            headers: { "x-token": this.userT.token}
          })
          .then(() => {
             this.showModalA = false;
          Vue.toasted.info((nombre+" Activado"),this.options);
            this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
             Vue.toasted.error("Error para activar",this.options);
          });
      
   
    },
    //Guardar registro
    save(){
      const { nombre, descripcion  } =this.formMarca;
      const me = this;
      axios
        .post(process.env.VUE_APP_URL + "marcas/store", {
          nombre: nombre,
          descripcion: descripcion
        },{
            headers: { "x-token": this.userT.token}
          })
        .then(() => {
        Vue.toasted.success((nombre+" Guardado"),this.options);
          me.$refs.vuetable.refresh();
          this.showModalN = false;
          this.limpiarModal();
          this.submitted = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
           Vue.toasted.error("Error para guardar",this.options);
        }).finally(() =>{
        
       this.showModalL= false;
        });

     
      
      
    },
 //ACtualizar registro
    update(){
      const { nombre, descripcion,id  } =this.formMarca;
      const me = this;
      axios
        .put(process.env.VUE_APP_URL + "marcas/update", {
          id: id,
          nombre: nombre,
          descripcion: descripcion,
          
        },{
            headers: { "x-token": this.userT.token}
          })
        .then(() => {
          Vue.toasted.success((nombre+" Actualizado"),this.options);
          me.$refs.vuetable.refresh();
          this.showModalE = false;
          this.limpiarModal();
          this.submitted = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar",this.options);
        }).finally(() =>{
        
       this.showModalL= false;
        });
   
    },

    //Timer de registro guardado para notificacion
     timer() {
      let timerInterval;
      Swal.fire({
        title: "Auto close alert!",
        html: "I will close in <b></b> milliseconds.",
        timer: 2000,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(() => {
            Swal.getContent().querySelector(
              "b"
            ).textContent = Swal.getTimerLeft();
          }, 100);
        },
        onClose: () => {
          clearInterval(timerInterval);
        }
      }).then(result => {
        if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log("I was closed by the timer"); // eslint-disable-line
        }
      });
    },
   //Buscador dentro de la tabala
    onFiltered(){
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
   //enviar datos a la Paginacion
    onPaginationData(paginationData) {
     
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

     //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    //Para abrir los modales y pasar los datos de la fila
    onActionClicked(action, data) {
      if(action=="edit-item"){
        this.formMarca.nombre=data.nombre_marca;
        this.formMarca.descripcion=data.descripcion_marca;
        this.formMarca.id=data.id;
        this.showModalE = true
      }
       if(action=="new-item"){
        this.formMarca.nombre="";
        this.formMarca.descripcion="";
        this.showModalN = true
      }
       if(action=="desactivate-item"){
        this.formMarca.nombre=data.nombre_marca;
        this.formMarca.id=data.id;
        this.showModalD = true
      }
      if(action=="activate-item"){
        this.formMarca.nombre=data.nombre_marca;
        this.formMarca.id=data.id;
        this.showModalA = true
      }
    }

  
  },
   computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  
    }
};
</script>
<style>
/* Css para el loading en el modal */
.my-class{
   background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}

</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">

   
            <b-modal
              centered
              v-model="showModalL"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
              no-close-on-backdrop
             content-class="my-class"
             header-class="my-class"
                  >
                    <template #modal-header="">
                <!-- Emulate built in modal header close button action -->
                  
                  <h5></h5>
                </template>
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="d-flex justify-content-center">
                            
                         <fulfilling-bouncing-circle-spinner
                          :animation-duration="2000"
                          :size="90"
                          color="#2a3042"
                          />
                          </div>
                        </div>
                      
                       
                      </div>

                      
                    </form>
            </b-modal>

  <!-- Modal para Activar -->  
            <b-modal
              centered
              v-model="showModalA"
              title="Activar Marca"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            
                          <h4>¿Desea activar la Marca {{formMarca.nombre}}?</h4>
                            
                          </div>
                        </div>
                      
                       
                      </div>

                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalA = false">Cancelar</b-button>
                         <b-button variant="danger" @click="activate">Activar</b-button>
                      </div>
                    </form>
            </b-modal>


 <!-- Modal para Desactivar -->  
            <b-modal
              centered
              v-model="showModalD"
              title="Desactivar"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            
                         <h4>¿Desea desactivar la Marca {{formMarca.nombre}}?</h4>
                            
                          </div>
                        </div>
                      
                       
                      </div>

                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalD = false">Cancelar</b-button>
                         <b-button variant="danger" @click="desactivate">Desactivar</b-button>
                      </div>
                    </form>
            </b-modal>



      <!-- Modal para Editar-->  
            <b-modal
              centered
              v-model="showModalE"
              title="Editar Marca"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form @submit.prevent="validaciones('update')">
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="name">Nombre</label>
                            <input
                              id="name"
                              v-model="$v.formMarca.nombre.$model"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese un nombre"
                              :class="{
                                'is-invalid': $v.formMarca.nombre.$error,
                              }"
                              @input="$v.formMarca.nombre.$touch()"
                            />
                            <div
                              v-if="  $v.formMarca.nombre.$error &&!$v.formMarca.nombre.required
                              "
                              class="invalid-feedback"
                            >
                              El nombre es obligatorio.
                            </div>
                            <div
                              v-if="!$v.formMarca.nombre.isUnique"
                              :class="{
                                'invalid-feedback': !$v.formMarca.nombre.isUnique,
                              }"
                            >
                                El nombre de la marca {{formMarca.nombre}} ya existen en nuestros registros.
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="phone">Descripción</label>
                            <input
                              id="phone"
                              v-model="formMarca.descripcion"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese una Descripción"
                              :class="{
                                'is-invalid':
                                  submitted && $v.formMarca.descripcion.$error,
                              }"
                            />
                            <div
                              v-if="submitted && !$v.formMarca.descripcion.required"
                              class="invalid-feedback"
                            >
                              La descripción es requerida.
                            </div>
                          </div>
                        </div>
                        
                       
                      </div>

                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalE = false">Cerrar</b-button>
                        <b-button type="submit" variant="success" class="ms-1"
                          >Guardar</b-button
                        >
                      </div>
                    </form>
            </b-modal>

        <!-- Modal de Nuevo Registro-->  
            <b-modal
              centered
              v-model="showModalN"
              title="Nueva Marca"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form @submit.prevent="validaciones('save')">
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="name">Nombre</label>
                            <input
                              id="name"
                              v-model="$v.formMarca.nombre.$model"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese un nombre"
                              :class="{
                                'is-invalid': $v.formMarca.nombre.$error,
                              }"
                              @input="$v.formMarca.nombre.$touch()"
                            />
                            <div
                              v-if="  $v.formMarca.nombre.$error &&!$v.formMarca.nombre.required
                              "
                              class="invalid-feedback"
                            >
                              El nombre es obligatorio.
                            </div>
                            <div
                              v-if="!$v.formMarca.nombre.isUnique"
                              :class="{
                                'invalid-feedback': !$v.formMarca.nombre.isUnique,
                              }"
                            >
                                El nombre de la marca {{formMarca.nombre}} ya existen en nuestros registros.
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="phone">Descripción</label>
                            <input
                              id="phone"
                              v-model="formMarca.descripcion"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese una Descripción"
                              :class="{
                                'is-invalid':
                                  submitted && $v.formMarca.descripcion.$error,
                              }"
                            />
                            <div
                              v-if="submitted && !$v.formMarca.descripcion.required"
                              class="invalid-feedback"
                            >
                              La descripción es requerida.
                            </div>
                          </div>
                        </div>
                        
                       
                      </div>

                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalN = false">Cerrar</b-button>
                        <b-button type="submit" variant="success" class="ms-1"
                          >Guardar</b-button
                        >
                      </div>
                    </form>
            </b-modal>

         <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Marcas</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      @input="changePageSize()"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2 ">
                    <div id="tickets-table_length" class="dataTables_length text-md-end ">
                      <label class="d-inline-flex align-items-center">
                         
                        <b-dropdown
                          v-if="searchType"
                          id="ddown1"
                          size="sm" 
                        >
                         <template v-slot:button-content>
                                    {{'Ordenar por: '+ searchLabel.nombre}}
                                    <i class="mdi mdi-chevron-down"></i>
                          </template>
                          <b-dropdown-item
                            v-for="(search, index) in searchType"
                            :key="index"
                            @click="changeTypeSearch(search)"
                            >{{ search.nombre }}</b-dropdown-item
                          >
                        </b-dropdown>
                      </label>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-3 text-md-start">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          v-model="search"
                          type="search"
                          @input="onFiltered()"
                          placeholder="Buscar..."
                          class="form-control form-control-sm "
                        ></b-form-input>
                      </label>
                    </div>
                  </div>


               <div class="col-sm-12 col-md-5">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                   <button
                    type="button"
                    class="btn btn-success btn-rounded mb-2 me-2"
                     @click="onActionClicked('new-item')"
                  >
                    <i class="mdi mdi-plus me-1"></i> Nueva Marca
                  </button>
                  </label>
                </div>
                
              </div>

           
              <!-- End search -->
            </div>
            <!-- Table -->
        <Loader :loading="loadingtable">
          <!-- Desktop (>= md): tabla -->
          <div class="d-none d-lg-block">
          <vuetable ref="vuetable"
           class="table-divided table-responsive order-with-arrow"
            :css="css.table"

            :http-options="httpOptions"
           :api-url="apiBase"
            :reactive-api-url="true"
            :fields="fields"
            :per-page="perPage"
            :query-params="makeQueryParams"
            pagination-path
            @vuetable:pagination-data="onPaginationData">
            <div slot="actions" slot-scope="props">
               <b-button-group class="mt-4 mt-md-0">
                  <b-button v-if="props.rowData.estado_marca" tabindex="0" v-b-tooltip.focus title="Editar" variant="outline-primary"
                    @click="onActionClicked('edit-item', props.rowData)"
                  ><i class="bx bx-edit-alt"></i>
                  </b-button>
              

                  <b-button tabindex="0" v-b-tooltip.focus title="Cambiar Estado" :variant="
                   props.rowData.estado_marca==true
                   ? 'outline-danger'
                    : 'outline-success'
                  "
                   @click="
                  props.rowData.estado_marca == true
                    ? onActionClicked('desactivate-item', props.rowData)
                    : onActionClicked('activate-item', props.rowData);
                "
                  >
                  <i :class="
                  props.rowData.estado_marca == true
                      ? 'bx bx-trash-alt'
                      : 'bx bx-list-check'"></i>
                  </b-button>
                
                

                 
               </b-button-group>
            </div>

            <div slot="estado" slot-scope="props">
              <h5 v-if="props.rowData.estado_marca == true">
            
               <span class="badge bg-success ms-1"><strong>ACTIVO</strong></span>
            </h5>
            <h5 v-else>
               <span class="badge bg-danger ms-1"><strong>INACTIVO</strong></span>
            </h5>


            </div>



		</vuetable>
          </div>

          <!-- Móvil (< md): cards -->
          <ResponsiveCards :items="items">
            <template #card="{ item }">
              <div class="rwd-card__head">
                <span v-if="item.estado_marca" class="badge bg-success">ACTIVO</span>
                <span v-else class="badge bg-danger">INACTIVO</span>
                <b-dropdown variant="primary" size="sm" right>
                  <template v-slot:button-content>
                    Opciones <i class="mdi mdi-chevron-down"></i>
                  </template>
                  <b-dropdown-item-button
                    v-if="item.estado_marca"
                    @click="onActionClicked('edit-item', item)">
                    <i class="bx bx-edit-alt"></i> Editar
                  </b-dropdown-item-button>
                  <b-dropdown-item-button
                    @click="
                      item.estado_marca == true
                        ? onActionClicked('desactivate-item', item)
                        : onActionClicked('activate-item', item)">
                    <i :class="item.estado_marca == true ? 'bx bx-trash-alt' : 'bx bx-list-check'"></i>{{ item.estado_marca ? " Desactivar" : " Activar" }}
                  </b-dropdown-item-button>
                </b-dropdown>
              </div>
              <div class="rwd-card__title">{{ item.nombre_marca }}</div>
              <div class="rwd-card__sub">{{ item.descripcion_marca }}</div>
            </template>
          </ResponsiveCards>

        <div style="padding-top:10px">
          <vuetable-pagination ref="pagination"
          :css="css.pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </div>
           
           </Loader>
           
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
